export default "__VITE_ASSET__5c614a17__"